import { ChangeDetectionStrategy,Component , ViewEncapsulation } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { IPasswordInput, ITextInput } from '../../interface';
import { InputsModule } from '../../inputs.module';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
    selector: 'input-password',
    templateUrl: './password.component.html',
    styleUrl: './password.component.scss',
    imports: [InputsModule, InlineSVGModule],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputPasswordComponent extends BaseInputComponent<IPasswordInput> {
  eye=false;
  
  constructor() {
    super();

  }
}
